module.exports = __webpack_public_path__ + "img/maintenance-icon.b2a37702.svg";